<script>
import { FormValidator, InputValidator } from '../form.js';
import { firestore } from '../firebase';
import * as utils from '../utils.js';
import Header from './header.svelte';
import Button from './button.svelte';
import { onMount } from 'svelte';

let formValidator = FormValidator();
let sending = false;

let name = '';
let email = '';
let subject = '';
let text = '';

let sent = false;

$:sendButtonState = sent ? 'disabled' : (sending ? 'loading' : '');

function Submit()
{
    if ($formValidator !== 1 || sent)
    {
        console.log('ignoring....');
        return;
    }

    sending = true;

    // send the contact information up as a document
    const now = utils.Now();
    const data = { name, email, subject, text, lastmod:now, created:now}
    let uuid = utils.UUID();

    firestore.collection('ContactForm').doc(uuid).set(data).then(() => {

        // uh delay this slightly so it looks like we did something
        setTimeout(() => {
            sending = false;
            sent = true;
            Alert("Your message has been sent. We will contact you soon!");
        }, 300);
    });
}

onMount(() => { window.scrollTo(0,0); });

</script>

<Header/>

<div class="container main medium" style="margin-top: 2.5em;">
  <section>
    <header class="line-after">
        <h3>Contact Us</h3>
    </header>
    <form on:submit|preventDefault={Submit}>
    <div class="row gtr-uniform gtr-50">
      <div class="col-12 col-12-xsmall">
          <label for="name">Name</label>
          <input use:InputValidator={formValidator} type="text" name="name" id="name" bind:value={name} placeholder="Name" />
          <div class="errorMsg">This field is required</div></div>
      <div class="col-12 col-12-xsmall">
          <label for="email">Email</label>
          <input use:InputValidator={formValidator} type="email" name="email" id="email" bind:value={email} placeholder="Email" />
        <div class="errorMsg">Please use a valid email</div>
      </div>
      <div class="col-12">
          <label for="subject">Subject</label>
          <input use:InputValidator={formValidator} type="text" name="subject" id="subject" bind:value={subject} placeholder="Subject" />
          <div class="errorMsg">This field is required</div>
      </div>
      <div class="col-12">
          <textarea use:InputValidator={formValidator} name="message" id="message" placeholder="Enter your message" bind:value={text} rows="6" style="background-color: rgb(0 0 0 / .3); color: #fff;"></textarea>
        <div class="errorMsg">This field is required</div>
      </div>
      <div class="col-12">
        <ul class="actions special">
            <li><Button state={sendButtonState} class="button fit primary" text="Send Message"/></li>
        </ul>
        </div>
      </div>
    </form>
</div>

<style>

label
{
    color: white;
    font-weight: normal;
    margin-bottom: .5em;
}

input[type="submit"] {
  background-color: rgb(0 0 0 / .3);
  box-shadow: none !important;
  color: #fff !important;
  width: 100%;
}


header.major { margin: 1em 0 0 0; }
header.line-after:after {
  content: '';
  display: inline-block;
  width: 10em;
  height: 0.25rem;
  margin: 0em 0 1.5em 0;
  border-radius: 4px;
  background-color: #4a98e2;
}

@media screen and (max-width: 480px) {
  .container > section.line-after:after {
    width: 100%;
    height: 0.25rem;
    margin: 1em 0;
  }
}

@media screen and (max-width: 736px) {
  .image > img {
    max-width: 90%;
    margin: 0 auto;
  }
}

form a
{
    color: rgb(103, 189, 255);
    border-bottom: 0;
}

input.error
{
    border-color: red;
    border-width: 2px;
}

.container.medium.main {
  background-color: #1a242f !important;
  padding-top: 0;
  font-size: 13pt;
}

.container.medium.main input {
    background-color: rgb(0 0 0 / .3);
}

.container.medium.main h4, .container.medium.main h6, input, label, h2, h3 {
  color: #fff !important;
}

label {font-weight: 400;}

.container.medium.main {
  width: 500px;
  max-width: 500px;
}

@media screen and (max-width: 736px) {
  .container.medium.main {
    width: 425px;
  }
}

@media screen and (max-width: 480px) {
  .container.medium.main {
    width: 275px;
  }
}

@media screen and (max-width: 320px) {
  .container.medium.main {
    width: 250px;
  }
}


ul.actions.special >li { width: 100%; margin: 0;}


.errorMsg
{
    padding-left:10px;
    display:none;
    color: red;
    text-align: left;
}


</style>
